import React from "react"

const SolutionLevelScheduledReportExportContext = React.createContext(null)

export default SolutionLevelScheduledReportExportContext
